import React, { useState } from 'react';
import ReactHtmlParser from 'react-html-parser';

import {
  useExceptionFormSelector,
  CreateExceptionAction,
  ExceptionFormContainer,
  ResetExceptionAction,
} from '@amzn/awsscmui-argo-inventory-exception/common/main';
import { Modal, Box, SpaceBetween, StatusIndicator, Button, Header, ModalProps } from '@amzn/awsui-components-react-v3';

import { isEmpty } from 'lodash';

import { BoostExceptionWorkRequestUrl } from '../../boost/utils';
import { GetExeceptionURL } from '../Utils';
import {
  CUT_A_TICKET_MESSAGE,
  DEFAULT_ERROR_MESSAGE,
  EXCEPTION_ERROR_CODES,
  HANDLED_EXCEPTION_CODES,
} from './constants';
import { ExceptionsModalProps, NotifyProps } from './types';

export const ExceptionModal = ({ show, onDismiss, form, notify, formState, appConfig }: ExceptionsModalProps) => {
  const [visible, setVisible] = useState(show);

  const exceptionOptions = useExceptionFormSelector({
    appConfig,
    form,
    notify: false,
  });

  const appConfigLoading = appConfig?.loadingResolverConfig || appConfig?.loading;

  const onDismissModal = ({ detail }: { detail: ModalProps.DismissDetail }) => {
    if (detail.reason === 'keyboard' || detail.reason === 'overlay') {
      return;
    }
    onDismiss();
    setVisible(false);
  };

  const generateErrorMessage = (notify: NotifyProps): string => {
    var exceptionsErrorMessage = DEFAULT_ERROR_MESSAGE;
    const graphQLExceptionCode = notify?.error?.context?.error?.graphQLErrors?.[0].extensions?.exception?.code;
    const errorMessage = notify?.error?.context?.error?.graphQLErrors?.[0]?.message;
    if (HANDLED_EXCEPTION_CODES.includes(graphQLExceptionCode)) {
      // if it's a handled exception, display additional context to the user.
      switch (graphQLExceptionCode) {
        case 'InvalidParameterException':
          exceptionsErrorMessage =
            EXCEPTION_ERROR_CODES['InvalidParameterException'] + errorMessage + '<br>' + CUT_A_TICKET_MESSAGE;
          break;

        case 'ConcurrentWriteException':
          exceptionsErrorMessage = EXCEPTION_ERROR_CODES['ConcurrentWriteException'];
          break;

        case 'DependencyException':
          exceptionsErrorMessage = EXCEPTION_ERROR_CODES['DependencyException'];
          break;
      }
    }

    return ReactHtmlParser(exceptionsErrorMessage);
  };
  return (
    <Modal
      onDismiss={onDismissModal}
      visible={visible}
      size="large"
      closeAriaLabel="close exceptions Model"
      header={
        <Header
          variant="h1"
          description={
            'Create Receiving exception so they can be searched, edited, and resolved. Fill out as much information as possible.'
          }
        >
          {'Create a Receiving Exception'}
        </Header>
      }
      footer={
        <Box float="right">
          {isEmpty(notify) && (
            <SpaceBetween direction="horizontal" size="xs">
              <ResetExceptionAction form={form} />
              <CreateExceptionAction form={form} />
            </SpaceBetween>
          )}
          {!isEmpty(notify) && <Button onClick={({ detail }: any) => onDismissModal({ detail })}>Close</Button>}
        </Box>
      }
    >
      {appConfigLoading && (
        <StatusIndicator type="loading">
          <span>Loading</span>
        </StatusIndicator>
      )}
      {!isEmpty(notify) && (
        <StatusIndicator type={isEmpty(notify?.success) ? 'error' : 'success'}>
          {isEmpty(notify?.success) ? generateErrorMessage(notify) : 'Successfully created exception'}
          {!isEmpty(notify?.success) && isEmpty(notify?.success?.context?.boostExceptionWorkRequestId) && (
            <Box margin={{ left: 's' }} variant="span">
              <GetExeceptionURL
                referenceId={undefined}
                path={notify?.success?.context?.exceptionId}
                target="_blank"
                title={notify?.success?.context?.title}
              />
            </Box>
          )}
          {!isEmpty(notify?.success?.context?.boostExceptionWorkRequestId) && (
            <Box margin={{ left: 's' }} variant="span">
              <BoostExceptionWorkRequestUrl
                workRequestId={notify?.success?.context?.boostExceptionWorkRequestId}
                title={notify?.success?.context?.title}
              />
            </Box>
          )}
        </StatusIndicator>
      )}

      {isEmpty(notify) && !appConfigLoading && (
        <ExceptionFormContainer
          isEditForm={false}
          form={form}
          formState={{ ...formState }}
          exceptionTypes={exceptionOptions?.exceptionTypes || []}
          assignedToGroups={exceptionOptions?.assignedToGroups}
        />
      )}
    </Modal>
  );
};
